import React from 'react';
import YesNoRadio from '../yes-no-radio';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS } from '../../util/constants';
const LABELS = {
  ARHI: DEFAULT_LABELS.ADD_PARTNER_RADIO
};
const AddPartnerRadio = props => {
  var _a;
  return React.createElement(YesNoRadio, {
    ...props,
    label: props.label || LABELS[(_a = props.funnel) !== null && _a !== void 0 ? _a : ''] || LABELS.ARHI
  });
};
const AddPartnerRadioWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AddPartnerRadio, {
  ...props
}));
export default AddPartnerRadioWithFunnel;